module.exports = __webpack_public_path__ + "img/album04_06.b88d16d8.jpg";